import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectSpendingTypes } from "../../Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { getAllSpendingProjectList } from "../../Thunks/HeyTraderThunks";

interface ProjectSpendingSliceState {
  loader: boolean; // for refres pages and inital loadings
  spendingProjectList: ProjectSpendingTypes[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: ProjectSpendingSliceState = {
  loader: false,
  spendingProjectList: [],
  errorDisplay: '',
}

// set state value for api response
const projectSpendingSlice = createSlice({
  name: 'spendingProject',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllSpendingProjectList.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getAllSpendingProjectList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAllSpendingProjectList.fulfilled, (state, action: PayloadAction<ProjectSpendingTypes[]>) => {
        state.loader = false;
        state.spendingProjectList = action.payload;
      })
  }
})

export const { } = projectSpendingSlice.actions
export default projectSpendingSlice.reducer

